<div class="modal fade modal-background" id="mobileNumberVerificationModal" #mobileNumberVerificationModal tabindex="-1" role="dialog" data-bs-backdrop="static" aria-labelledby="modalLabel" aria-hidden="true" (click)="onContainerClicked($event)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-header header-nav">
        <span i18n="@@loginPageTitle" class="title-nav">Login</span>
        <div>
          <button type="button" class="modal-close-button" (click)="closeModal()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

      </div>

        <div class="modal-body">
          <div>
            <div class="full-width">

              <div class="form-div">
                <div class="header">
                  <div class="logo">
                    <img src="assets/logo-full.svg"/>
                  </div>
                  <!--          <h2 i18n="@@merchantLoginTitle">Login to your account as:</h2>-->
                  <p class="note-Message" *ngIf="warningMessage?.hasActualValue()">{{warningMessage}}</p>
                </div>
                <!-- emailItem -->
                <input-text-field (onchange)="updateInputFieldById('email', $event)"
                                  [errorHandling]="errorHandling"
                                  [floatingLabel]="emailLabel"
                                  [group]="signInForm"
                                  [id]="'email'"
                                  [inputType]=InputType.email
                                  [validators]=[Validators.required,Validators.email]
                ></input-text-field>
                <!-- PasswordItem -->
                <input-text-field (onchange)="updateInputFieldById('password', $event)"
                                  [errorHandling]="errorHandling"
                                  [floatingLabel]="passwordLabel"
                                  [group]="signInForm"
                                  [id]="'password'"
                                  [inputType]=InputType.password
                                  [validators]=[Validators.required]>
                </input-text-field>
                <div class="forget-password">
                  <button (click)=" onForgotPassword()" class="forget-password-button btn" i18n="@@forgotPasswordTitle">Forgot
                    password?
                  </button>
                </div>

                <div *ngIf="serverError !== null"
                     class="alert alert-danger form-alert">{{ serverError }}
                </div>
                <primary-button
                  (onClick)="onLoginSubmitted()"
                  [loading]="isLoading"
                  [showArrow]="true"
                  [title]="loginLabel">
                </primary-button>
                <div class="text-center">
                  <p i18n="@@dontHaveAccount">Don't have an account? <a [routerLink]="goToSignup()" class="sign-up">Sign up</a>
                  </p>
                </div>
              </div>


            </div>
          </div>
        </div>

    </div>
  </div>
</div>






